@if (documentTypeId) {
<div class="accordion-item">
  <h5 class="accordion-header m-0" id="heading{{documentTypeId}}">
    <button class="accordion-button {{allExpanded ? '' : 'collapsed'}} fw-semibold" type="button"
      data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse'+documentTypeId" aria-expanded="true"
      [attr.aria-controls]="'#collapse'+documentTypeId">
      {{documentTypeName}}
    </button>
  </h5>
  <div id="collapse{{documentTypeId}}" class="accordion-collapse collapse {{ allExpanded ? 'show' : '' }}"
    aria-labelledby="heading{{documentTypeId}}">
    <div class="accordion-body">
      @if (documentTypeId) {
      <p-table #dt1 [value]="filteredFiles" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[10,25,50]"
        [showCurrentPageReport]="true"
        [globalFilterFields]="['fileName','taskStatus', 'conditionStatus','conditionId','note','dateInserted','exportDate']"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        styleClass="p-datatable-gridlines" dataKey="guid" [(selection)]="selectedRows">
        <ng-template pTemplate="caption">
          <div class="p-d-flex">
            <p-iconfield class="p-ml-auto">
              <input pInputText #searchText type="text" class="form-control" (ngModelChange)="dt1.first=0"
                (input)="dt1.filterGlobal(searchText.value, 'contains')" placeholder="Search keyword" />
              <p-inputicon styleClass="pi pi-search" />
            </p-iconfield>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th class="text-center">
              <p-tableHeaderCheckbox (click)="onSelectAllByDocumentClicked()">
              </p-tableHeaderCheckbox>
            </th>
            <th [pSortableColumn]="'fileName'"><div class="d-flex align-items-center justify-content-between"><span>
              File Name
              </span><p-sortIcon [field]="'fileName'"></p-sortIcon></div></th>
            <th [pSortableColumn]="'taskStatus'"><div class="d-flex align-items-center justify-content-between"><span>
              Task Status
              </span><p-sortIcon [field]="'taskStatus'"></p-sortIcon></div></th>
            <th [pSortableColumn]="'condition'" class="text-center">
              Condition
            </th>
            <th [pSortableColumn]="'conditionStatus'"><div class="d-flex align-items-center justify-content-between"><span>
              Condition Status
              </span><p-sortIcon [field]="'conditionStatus'"></p-sortIcon></div></th>
            <th [pSortableColumn]="'conditionId'"><div class="d-flex align-items-center justify-content-between"><span>
              Condition Id
              </span><p-sortIcon [field]="'conditionId'"></p-sortIcon></div></th>
            <th [pSortableColumn]="'note'"><div class="d-flex align-items-center justify-content-between"><span>
              Note
              </span><p-sortIcon [field]="'note'"></p-sortIcon></div></th>
            <th [pSortableColumn]="'dateInserted'"><div class="d-flex align-items-center justify-content-between"><span>
              Created Date
              </span><p-sortIcon [field]="'dateInserted'"></p-sortIcon></div></th>
            <th [pSortableColumn]="'exportDate'"><div class="d-flex align-items-center justify-content-between"><span>
              Exported Date
              </span><p-sortIcon [field]="'exportDate'"></p-sortIcon></div></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-docFile let-rowIndex="rowIndex">
          <tr [ngClass]="{'color-export': docFile.exportDate != null}">
            <td class="text-center">
              <p-tableCheckbox [value]="docFile" [id]="docFile.docFileId + '_' + rowIndex"
                (click)="onToggleCheckboxClicked(docFile)">
              </p-tableCheckbox>
            </td>
            <td>
              <a (click)="onViewDocFileClicked(docFile)" title="Show the Document" class="mx-2">
                {{docFile.fileName}}
              </a>
              <a (click)="onDownloadDocumentClicked(docFile)" title="Download">
                <i class="fas fa-download"></i>
              </a>
            </td>
            <td> {{docFile.taskStatus}} </td>
            <td>
              {{docFile.condition ? 'Yes' : 'No'}}
            </td>
            <td> {{docFile.conditionStatus}} </td>
            <td [ngClass]="{'text-center': !docFile.conditionId}">
              {{docFile.condition ? docFile.conditionId: '-'}} </td>
            <td> {{docFile.note}} </td>
            <td> {{docFile.dateInserted | date: dateFormat}} </td>
            <td> {{docFile.exportDate | date: dateFormat}} </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="9" class="text-center"> No document found. </td>
          </tr>
        </ng-template>
      </p-table>
      }
    </div>
  </div>
</div>
}